import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import get from 'lodash/get';

import {
  getAvailableOptions,
  setSelectedOptionId,
  resetSubscriptionErrors,
  subscribeSelectedOption,
  resetPromoCode,
} from '@app/actions/subscribeActions';
import {
  Loader, Package, PromoRedemption, Button, ErrorMessage,
} from '@app/components';
import colors from '@app/constants/colors';
import RouterConstants from '@app/constants/router';

class SelectOption extends React.Component {
  componentDidMount() {
    const { resetPromoCode, getAvailableOptions } = this.props;
    resetPromoCode();
    getAvailableOptions();
  }

  componentWillUnmount() {
    const { resetSubscriptionErrors } = this.props;
    resetSubscriptionErrors();
  }

  setOption = (option = {}) => {
    const { setSelectedOptionId } = this.props;
    setSelectedOptionId(option.idOption);
  };

  renderAvailableOptions = () => {
    const {
      availableOptions,
      selectedOptionId,
      isSubscriptionActive,
    } = this.props;

    return availableOptions && availableOptions.length
      ? availableOptions.map(option => (
        <Package
          key={option.idOption}
          option={option}
          selected={selectedOptionId === option.idOption}
          disabled={isSubscriptionActive}
          onOptionSelect={this.setOption}
        />
      ))
      : <span><FormattedMessage id="subscribe.noPackages" /></span>;
  };

  render() {
    const {
      isCheckingPromoCode,
      isOptionAvailable,
      isLoadingOptions,
      isSubscriptionActive,
      selectedOptionId,
      isLoggedIn,
      history,
      error,
      subscribeSelectedOption,
      isPurchaseInProgress,
    } = this.props;

    return (
      <PageContainer>
        {
          error && (
            <ErrorMessage>
              <FormattedMessage id={`subscribe.errors.${get(error, 'code')}`} />
            </ErrorMessage>
          )
        }
        <Packages>
          {
            isLoadingOptions ? <Loader /> : this.renderAvailableOptions()
          }
          {
            !isLoadingOptions && isOptionAvailable && <PromoRedemption />
          }
        </Packages>
        <Button
          labelId="subscribe.button.next"
          textColor={colors.ALICE_BLUE}
          backgroundColor={colors.INTERNATIONAL_ORANGE}
          onClick={() => (isLoggedIn
            ? subscribeSelectedOption()
            : history.push(RouterConstants.SIGN_UP))
          }
          disabled={isLoadingOptions || !selectedOptionId || isSubscriptionActive || isCheckingPromoCode}
          loading={isPurchaseInProgress}
        />
      </PageContainer>
    );
  }
}

SelectOption.propTypes = {
  getAvailableOptions: PropTypes.func.isRequired,
  setSelectedOptionId: PropTypes.func.isRequired,
  resetSubscriptionErrors: PropTypes.func.isRequired,
  subscribeSelectedOption: PropTypes.func.isRequired,
  resetPromoCode: PropTypes.func.isRequired,
  isLoadingOptions: PropTypes.bool.isRequired,
  isOptionAvailable: PropTypes.bool.isRequired,
  isSubscriptionActive: PropTypes.bool.isRequired,
  isPurchaseInProgress: PropTypes.bool.isRequired,
  isCheckingPromoCode: PropTypes.bool.isRequired,
  availableOptions: PropTypes.arrayOf(Object),
  selectedOptionId: PropTypes.oneOfType([PropTypes.number]),
  history: PropTypes.oneOfType([PropTypes.object]).isRequired,
  isLoggedIn: PropTypes.bool.isRequired,
  error: PropTypes.shape({
    code: PropTypes.number.isRequired,
    message: PropTypes.string,
  }),
};

SelectOption.defaultProps = {
  availableOptions: [],
  selectedOptionId: null,
  error: null,
};

const mapStateToProps = ({
  subscribe:
    {
      isLoadingOptions,
      isSubscriptionActive,
      availableOptions,
      selectedOptionId,
      error,
      isPurchaseInProgress,
    },
  user: { isLoggedIn },
  form,
}) => ({
  isCheckingPromoCode: get(form, 'PromoRedemption.submitting', false),
  isOptionAvailable: Boolean(availableOptions && availableOptions.length),
  isLoadingOptions,
  isSubscriptionActive,
  availableOptions,
  selectedOptionId,
  isLoggedIn,
  error,
  isPurchaseInProgress,
});

const mapDispatchToProps = {
  resetSubscriptionErrors,
  getAvailableOptions,
  setSelectedOptionId,
  resetPromoCode,
  subscribeSelectedOption,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SelectOption));

const PageContainer = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  width: 100%;
  min-height: 300px;
  padding: 20px 0;
`;

const Packages = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  text-align: center;
  width: 100%;
  min-height: 300px;
  padding: 80px 0;
  
  @media (max-width: 728px) {
    flex-direction: column;
  }  
`;
